import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import DashboardDropdown from "../DashboardDropdown";
import { GraphCardsHeader } from "@ui";

function MixedColumnChart({
  title,
  series,
  labels,
  exportCSVHeading = "Date,",
  yaxisFrontTitle = "",
  yaxisBackTitle = "",
  tooltip = "",
  showDownloadButtons = true,
  needCSVDownload = false,
  needImageDownload = false,
  showDropdown = false,
  filterBy = "",
  height = 300,
  updateFilterHandler = () => {},
}) {
  const chartRef = useRef(null);

  async function downloadPNG() {
    const chartInstance = chartRef.current;
    const base64 = await chartInstance.chart.dataURI();
    const downloadLink = document.createElement("a");
    downloadLink.href = base64.imgURI;
    downloadLink.download = "image.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function exportCSV() {
    let csvContent =
      exportCSVHeading + series.map((s) => s.name).join(",") + "\n";
    labels.forEach((category, index) => {
      let row = [category];
      series.forEach((series) => {
        row.push(series.data[index]);
      });
      csvContent += row.join(",") + "\n";
    });
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function downloadChart() {
    const chartInstance = chartRef.current;
    if (chartInstance) {
      downloadPNG(chartInstance);
    } else {
      console.error(`Chart not found.`);
    }
  }

  const chartOption = {
    series: series || [],
    options: {
      chart: {
        height: 380,
        type: "column",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: series.map((s) => (s.type === "line" ? 2 : 0)),
      },
      markers: {
        size: 4,
      },
      legend: {
        show: true,
        position: "bottom",
        offsetY: 5,
        markers: {
          width: 10,
          height: 10,
          radius: 50,
          shape: "circle",
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      xaxis: {
        categories: labels || [],
        tickAmount: 6,
        labels: {
          show: true,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          formatter: function (value) {
            if (!value || !value.length) return value;
            return value?.replace(/([0-9]+)\s(\w+)/, (_, day, month) => {
              return `${day} ${month?.charAt(0)?.toUpperCase()}${month?.slice(
                1
              )}`;
            });
          },
        },
      },
      yaxis: [
        {
          title: {
            text: yaxisFrontTitle,
          },
        },
        {
          opposite: true,
          title: {
            text: yaxisBackTitle,
          },
        },
      ],
    },
  };

  return (
    <Card className="flex-grow-1 d-flex flex-column mb-0">
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={showDownloadButtons}
        downloadImage={downloadChart}
        downloadCSV={exportCSV}
        needCSVDownload={needCSVDownload}
        needImageDownload={needImageDownload}
        rightComponent={
          showDropdown ? (
            <div className="d-flex gap-3 align-items-center justify-content-end">
              <div className="dropdown bg-white border border-1 rounded-3 px-3 py-2">
                <DashboardDropdown
                  constantFilterOption={["Daily", "Monthly"]}
                  handleDropdownChange={updateFilterHandler}
                  type={filterBy}
                />
              </div>
            </div>
          ) : (
            <></>
          )
        }
      />

      <Card.Body className="flex-grow-1">
        <div id="chart-basic-column-bar">
          <Chart
            ref={chartRef}
            options={chartOption.options}
            series={chartOption.series}
            type="bar"
            height={height}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default MixedColumnChart;
